import { gql } from '@apollo/client';

export const Form5300AnalysisFragment = gql`
  fragment Form5300Analysis on PrivateCompany {
    id
    form5300LLMAnalysis {
      emergingLendingRisks {
        portfolioGrowthRates
        lendingPortfolioAnalysis
        increasingDelinquencies
        benchmarkComparisons
        recessionSensitivityAnalysis
      }
      dataDrivenInsights
    }
  }
`;
